// Default artifacts data for the CSF assessment
// Based on JIRA-Artifacts.csv export from AR project
// These artifacts represent evidence documents collected during the assessment

export const DEFAULT_ARTIFACTS = [
  {
    id: 1,
    artifactId: 'AR-1',
    name: 'Phishing Campaign Results from Jan 2026',
    description: 'Phishing tool (Go Phish) campaign export of results',
    link: 'https://github.com/CPAtoCybersecurity/csf_profile/blob/main/public/Sample_Artifacts/2025-05-26_Phish-1001-LI-Campaign-Data.xlsx',
    complianceRequirement: null,
    controlId: 'PR.AT-01 Ex2', // Security awareness training control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-10T07:28:00.000Z',
    lastModified: '2026-01-10T10:14:00.000Z',
    jiraKey: 'AR-1',
    status: 'ACTIVE'
  },
  {
    id: 2,
    artifactId: 'AR-2',
    name: 'SOC-Ticket-1001',
    description: 'Sample case',
    link: 'https://github.com/CPAtoCybersecurity/csf_profile/commit/0977939cf00b964fdca5aa9339c24c6d12c23c56',
    complianceRequirement: null,
    controlId: null,
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-10T07:31:00.000Z',
    lastModified: '2026-01-10T07:32:00.000Z',
    jiraKey: 'AR-2',
    status: 'ACTIVE'
  },
  {
    id: 3,
    artifactId: 'AR-3',
    name: 'SOC-Ticket-1004',
    description: 'Sample case',
    link: 'https://github.com/CPAtoCybersecurity/csf_profile/blob/main/public/Sample_Artifacts/SOC-Ticket-1004.md',
    complianceRequirement: null,
    controlId: 'RS.MI-02 Ex2', // Incident eradication control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-10T07:31:00.000Z',
    lastModified: '2026-01-10T17:14:00.000Z',
    jiraKey: 'AR-3',
    status: 'ACTIVE'
  },
  {
    id: 4,
    artifactId: 'AR-4',
    name: 'SOC-Ticket-1005',
    description: 'Sample case',
    link: 'https://github.com/CPAtoCybersecurity/csf_profile/commit/104f9b021cc951d53947a99bbd0e44669adf4ebb',
    complianceRequirement: null,
    controlId: null,
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-10T07:31:00.000Z',
    lastModified: '2026-01-10T07:33:00.000Z',
    jiraKey: 'AR-4',
    status: 'ACTIVE'
  },
  {
    id: 5,
    artifactId: 'AR-5',
    name: 'Third Party Risk Management Policy',
    description: '',
    link: 'https://github.com/CPAtoCybersecurity/csf_profile/commit/3393340912d4d2e6a9607fa3d1ba251e8b9b23ce',
    complianceRequirement: null,
    controlId: null,
    linkedSubcategoryIds: [],
    type: 'Policy',
    createdDate: '2026-01-10T07:31:00.000Z',
    lastModified: '2026-01-10T07:33:00.000Z',
    jiraKey: 'AR-5',
    status: 'ACTIVE'
  },
  {
    id: 6,
    artifactId: 'AR-6',
    name: 'CloudTrail-Config-Exports.json',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'DE.CM-01 Ex1', // Network monitoring control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-11T14:35:00.000Z',
    lastModified: '2026-01-11T14:45:00.000Z',
    jiraKey: 'AR-6',
    status: 'ACTIVE'
  },
  {
    id: 7,
    artifactId: 'AR-7',
    name: 'VPC-FlowLog-Dashboard-Screenshots.png',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'DE.CM-01 Ex1', // Network monitoring control
    linkedSubcategoryIds: [],
    type: 'Screenshot',
    createdDate: '2026-01-11T14:35:00.000Z',
    lastModified: '2026-01-11T14:45:00.000Z',
    jiraKey: 'AR-7',
    status: 'ACTIVE'
  },
  {
    id: 8,
    artifactId: 'AR-8',
    name: 'Route53-DNS-Logging-Config-Screenshots.png',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'DE.CM-01 Ex1', // Network monitoring control
    linkedSubcategoryIds: [],
    type: 'Screenshot',
    createdDate: '2026-01-11T14:36:00.000Z',
    lastModified: '2026-01-11T14:45:00.000Z',
    jiraKey: 'AR-8',
    status: 'ACTIVE'
  },
  {
    id: 9,
    artifactId: 'AR-9',
    name: 'ASM-Vendor-Evaluation-Matrix.xlsx',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'DE.CM-01 Ex1', // Network monitoring control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-11T14:36:00.000Z',
    lastModified: '2026-01-11T14:45:00.000Z',
    jiraKey: 'AR-9',
    status: 'ACTIVE'
  },
  {
    id: 10,
    artifactId: 'AR-10',
    name: 'GuardDuty-Findings-Reports',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'DE.CM-01 Ex1', // Network monitoring control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-11T14:46:00.000Z',
    lastModified: '2026-01-11T14:46:00.000Z',
    jiraKey: 'AR-10',
    status: 'ACTIVE'
  },
  {
    id: 11,
    artifactId: 'AR-11',
    name: 'VPC-FlowLog-Retention-Remediation-Evidence',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'DE.CM-01 Ex1', // Network monitoring control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-11T14:46:00.000Z',
    lastModified: '2026-01-11T14:46:00.000Z',
    jiraKey: 'AR-11',
    status: 'ACTIVE'
  },
  {
    id: 12,
    artifactId: 'AR-12',
    name: 'ASM-Implementation-Status-Report',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: null,
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-11T14:46:00.000Z',
    lastModified: '2026-01-11T14:46:00.000Z',
    jiraKey: 'AR-12',
    status: 'ACTIVE'
  },
  {
    id: 13,
    artifactId: 'AR-13',
    name: 'SentinelOne-AppControl-Policy-Config',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.PS-05 Ex1', // Unauthorized software prevention control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-11T15:05:00.000Z',
    lastModified: '2026-01-11T15:05:00.000Z',
    jiraKey: 'AR-13',
    status: 'ACTIVE'
  },
  {
    id: 14,
    artifactId: 'AR-14',
    name: 'Mac-Endpoint-Inventory',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.PS-05 Ex1', // Unauthorized software prevention control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-11T15:06:00.000Z',
    lastModified: '2026-01-11T15:06:00.000Z',
    jiraKey: 'AR-14',
    status: 'ACTIVE'
  },
  {
    id: 15,
    artifactId: 'AR-15',
    name: 'SentinelOne-AppControl-Pilot-Report',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.PS-05 Ex1', // Unauthorized software prevention control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-11T15:06:00.000Z',
    lastModified: '2026-01-11T15:06:00.000Z',
    jiraKey: 'AR-15',
    status: 'ACTIVE'
  },
  {
    id: 16,
    artifactId: 'AR-16',
    name: 'SentinelOne-Policy-Violation-Alerts',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.PS-05 Ex1', // Unauthorized software prevention control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-11T15:06:00.000Z',
    lastModified: '2026-01-11T15:06:00.000Z',
    jiraKey: 'AR-16',
    status: 'ACTIVE'
  },
  {
    id: 17,
    artifactId: 'AR-17',
    name: 'MDM-Vendor-Evaluation',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.PS-05 Ex1', // Unauthorized software prevention control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-11T15:06:00.000Z',
    lastModified: '2026-01-11T15:06:00.000Z',
    jiraKey: 'AR-17',
    status: 'ACTIVE'
  },
  {
    id: 18,
    artifactId: 'AR-18',
    name: 'AWS-ALB-Configuration-Export',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.IR-03 Ex2', // Resilience mechanisms control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-11T15:20:00.000Z',
    lastModified: '2026-01-11T15:20:00.000Z',
    jiraKey: 'AR-18',
    status: 'ACTIVE'
  },
  {
    id: 19,
    artifactId: 'AR-19',
    name: 'Auto-Scaling-Group-Config-Screenshot',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.IR-03 Ex2', // Resilience mechanisms control
    linkedSubcategoryIds: [],
    type: 'Screenshot',
    createdDate: '2026-01-11T15:20:00.000Z',
    lastModified: '2026-01-11T15:20:00.000Z',
    jiraKey: 'AR-19',
    status: 'ACTIVE'
  },
  {
    id: 20,
    artifactId: 'AR-20',
    name: 'RDS-Multi-AZ-Configuration',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.IR-03 Ex2', // Resilience mechanisms control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-11T15:20:00.000Z',
    lastModified: '2026-01-11T15:20:00.000Z',
    jiraKey: 'AR-20',
    status: 'ACTIVE'
  },
  {
    id: 21,
    artifactId: 'AR-21',
    name: 'Kubernetes-HA-Architecture-Diagram',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.IR-03 Ex2', // Resilience mechanisms control
    linkedSubcategoryIds: [],
    type: 'Diagram',
    createdDate: '2026-01-11T15:20:00.000Z',
    lastModified: '2026-01-11T15:20:00.000Z',
    jiraKey: 'AR-21',
    status: 'ACTIVE'
  },
  {
    id: 22,
    artifactId: 'AR-22',
    name: 'CloudFront-Distribution-Config',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.IR-03 Ex2', // Resilience mechanisms control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-11T15:20:00.000Z',
    lastModified: '2026-01-11T15:20:00.000Z',
    jiraKey: 'AR-22',
    status: 'ACTIVE'
  },
  {
    id: 23,
    artifactId: 'AR-23',
    name: 'Auto-Scaling-Event-History',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.IR-03 Ex2', // Resilience mechanisms control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-11T15:21:00.000Z',
    lastModified: '2026-01-11T15:21:00.000Z',
    jiraKey: 'AR-23',
    status: 'ACTIVE'
  },
  {
    id: 24,
    artifactId: 'AR-24',
    name: 'RDS-Failover-Test-Results',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.IR-03 Ex2', // Resilience mechanisms control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-11T15:21:00.000Z',
    lastModified: '2026-01-11T15:21:00.000Z',
    jiraKey: 'AR-24',
    status: 'ACTIVE'
  },
  {
    id: 25,
    artifactId: 'AR-25',
    name: 'K8s-Pod-Distribution-Report',
    description: '',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.IR-03 Ex2', // Resilience mechanisms control
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-11T15:21:00.000Z',
    lastModified: '2026-01-11T15:21:00.000Z',
    jiraKey: 'AR-25',
    status: 'ACTIVE'
  },
  {
    id: 26,
    artifactId: 'AR-26',
    name: 'Application Control Policy',
    description: 'Policy governing authorized software installation and execution controls across endpoints and servers',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.PS-05 Ex1',
    linkedSubcategoryIds: [],
    type: 'Policy',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-26',
    status: 'ACTIVE'
  },
  {
    id: 27,
    artifactId: 'AR-27',
    name: 'Asset Inventory',
    description: 'Comprehensive inventory of hardware and software assets including cloud resources, containers, and VMs',
    link: '',
    complianceRequirement: null,
    controlId: 'ID.AM-02 Ex2',
    linkedSubcategoryIds: [],
    type: 'Report',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-27',
    status: 'ACTIVE'
  },
  {
    id: 28,
    artifactId: 'AR-28',
    name: 'Backup Procedures',
    description: 'Documented backup verification, integrity validation, and quarterly restore testing procedures',
    link: '',
    complianceRequirement: null,
    controlId: 'RC.RP-03 Ex1',
    linkedSubcategoryIds: [],
    type: 'Procedure',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-28',
    status: 'ACTIVE'
  },
  {
    id: 29,
    artifactId: 'AR-29',
    name: 'Board Approval Documentation',
    description: 'Board-approved documentation for risk management objectives and security investment decisions',
    link: '',
    complianceRequirement: null,
    controlId: 'GV.RM-01 Ex2',
    linkedSubcategoryIds: [],
    type: 'Evidence',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-29',
    status: 'ACTIVE'
  },
  {
    id: 30,
    artifactId: 'AR-30',
    name: 'Board Briefing Materials',
    description: 'Executive briefing materials prepared for Board cybersecurity governance presentations',
    link: '',
    complianceRequirement: null,
    controlId: 'GV.OC-01 Ex1',
    linkedSubcategoryIds: [],
    type: 'Evidence',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-30',
    status: 'ACTIVE'
  },
  {
    id: 31,
    artifactId: 'AR-31',
    name: 'Board Reports',
    description: 'Quarterly Board reports on security posture, KPI trends, and strategy outcomes',
    link: '',
    complianceRequirement: null,
    controlId: 'GV.OV-01 Ex2',
    linkedSubcategoryIds: [],
    type: 'Report',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-31',
    status: 'ACTIVE'
  },
  {
    id: 32,
    artifactId: 'AR-32',
    name: 'Change Management Policy',
    description: 'Policy governing change request documentation, risk impact assessment, and approval workflows',
    link: '',
    complianceRequirement: null,
    controlId: 'GV.SC-09 Ex5',
    linkedSubcategoryIds: [],
    type: 'Policy',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-32',
    status: 'ACTIVE'
  },
  {
    id: 33,
    artifactId: 'AR-33',
    name: 'Containment Playbooks',
    description: 'Incident response playbooks for automated and manual containment of security threats',
    link: '',
    complianceRequirement: null,
    controlId: 'RS.MI-01 Ex1',
    linkedSubcategoryIds: [],
    type: 'Procedure',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-33',
    status: 'ACTIVE'
  },
  {
    id: 34,
    artifactId: 'AR-34',
    name: 'DR Plan',
    description: 'Disaster recovery plan covering failover procedures, recovery objectives, and testing schedules',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.IR-03 Ex3',
    linkedSubcategoryIds: [],
    type: 'Procedure',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-34',
    status: 'ACTIVE'
  },
  {
    id: 35,
    artifactId: 'AR-35',
    name: 'Data Classification Policy',
    description: 'Policy defining data sensitivity levels, classification schema, and handling requirements by tier',
    link: '',
    complianceRequirement: null,
    controlId: 'ID.AM-07 Ex3',
    linkedSubcategoryIds: [],
    type: 'Policy',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-35',
    status: 'ACTIVE'
  },
  {
    id: 36,
    artifactId: 'AR-36',
    name: 'Data Handling Procedures',
    description: 'Procedures for data-in-use protection including memory handling, retention limits, and source code review',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.DS-10 Ex1',
    linkedSubcategoryIds: [],
    type: 'Procedure',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-36',
    status: 'ACTIVE'
  },
  {
    id: 37,
    artifactId: 'AR-37',
    name: 'Encryption Policy',
    description: 'Policy governing data-at-rest encryption standards, key management, and removable media controls',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.DS-01 Ex4',
    linkedSubcategoryIds: [],
    type: 'Policy',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-37',
    status: 'ACTIVE'
  },
  {
    id: 38,
    artifactId: 'AR-38',
    name: 'Environmental Threat Assessment',
    description: 'Assessment of physical and environmental threats to data center and cloud infrastructure',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.IR-02 Ex1',
    linkedSubcategoryIds: [],
    type: 'Evidence',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-38',
    status: 'ACTIVE'
  },
  {
    id: 39,
    artifactId: 'AR-39',
    name: 'Event Correlation Architecture',
    description: 'Documentation of log aggregation and event correlation architecture across CloudTrail and GuardDuty',
    link: '',
    complianceRequirement: null,
    controlId: 'DE.AE-03 Ex2',
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-39',
    status: 'ACTIVE'
  },
  {
    id: 40,
    artifactId: 'AR-40',
    name: 'Hardening Standards',
    description: 'System hardening baselines for Amazon Linux 2, Ubuntu, and Windows server configurations',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.PS-01 Ex1',
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-40',
    status: 'ACTIVE'
  },
  {
    id: 41,
    artifactId: 'AR-41',
    name: 'IAM Monitoring Configuration',
    description: 'Configuration documentation for identity and access monitoring via CloudTrail and SSO logging',
    link: '',
    complianceRequirement: null,
    controlId: 'DE.CM-03 Ex2',
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-41',
    status: 'ACTIVE'
  },
  {
    id: 42,
    artifactId: 'AR-42',
    name: 'Incident Declaration Criteria',
    description: 'Documented criteria and severity thresholds for declaring security incidents',
    link: '',
    complianceRequirement: null,
    controlId: 'DE.AE-08 Ex1',
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-42',
    status: 'ACTIVE'
  },
  {
    id: 43,
    artifactId: 'AR-43',
    name: 'Incident Priority Matrix',
    description: 'Matrix defining incident categorization and prioritization based on scope and impact',
    link: '',
    complianceRequirement: null,
    controlId: 'RS.MA-03 Ex2',
    linkedSubcategoryIds: [],
    type: 'Report',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-43',
    status: 'ACTIVE'
  },
  {
    id: 44,
    artifactId: 'AR-44',
    name: 'Incident Response Playbooks',
    description: 'Documented playbooks for incident eradication procedures with escalation paths and decision trees',
    link: '',
    complianceRequirement: null,
    controlId: 'RS.MI-02 Ex2',
    linkedSubcategoryIds: [],
    type: 'Procedure',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-44',
    status: 'ACTIVE'
  },
  {
    id: 45,
    artifactId: 'AR-45',
    name: 'Information Security Policy',
    description: 'Board-approved information security policy defining roles, responsibilities, and security requirements',
    link: '',
    complianceRequirement: null,
    controlId: 'GV.RR-02 Ex1',
    linkedSubcategoryIds: [],
    type: 'Policy',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-45',
    status: 'ACTIVE'
  },
  {
    id: 46,
    artifactId: 'AR-46',
    name: 'KPI Dashboard',
    description: 'Quarterly KPI tracking dashboard for cybersecurity metrics including TTD, TTI, and TTR',
    link: '',
    complianceRequirement: null,
    controlId: 'GV.OV-01 Ex2',
    linkedSubcategoryIds: [],
    type: 'Report',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-46',
    status: 'ACTIVE'
  },
  {
    id: 47,
    artifactId: 'AR-47',
    name: 'Log Review Procedures',
    description: 'Procedures for manual log review cadence, documentation requirements, and finding templates',
    link: '',
    complianceRequirement: null,
    controlId: 'DE.AE-02 Ex3',
    linkedSubcategoryIds: [],
    type: 'Procedure',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-47',
    status: 'ACTIVE'
  },
  {
    id: 48,
    artifactId: 'AR-48',
    name: 'Network Monitoring Architecture',
    description: 'Architecture documentation for network monitoring including CloudTrail, VPC Flow Logs, and DNS monitoring',
    link: '',
    complianceRequirement: null,
    controlId: 'DE.CM-01 Ex1',
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-48',
    status: 'ACTIVE'
  },
  {
    id: 49,
    artifactId: 'AR-49',
    name: 'RACI Matrix',
    description: 'Responsibility assignment matrix for security roles across security, IT, legal, and product teams',
    link: '',
    complianceRequirement: null,
    controlId: 'GV.RR-02 Ex1',
    linkedSubcategoryIds: [],
    type: 'Report',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-49',
    status: 'ACTIVE'
  },
  {
    id: 50,
    artifactId: 'AR-50',
    name: 'RFP Templates',
    description: 'Request for proposal templates with embedded supplier security requirements and clauses',
    link: '',
    complianceRequirement: null,
    controlId: 'GV.SC-02 Ex7',
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-50',
    status: 'ACTIVE'
  },
  {
    id: 51,
    artifactId: 'AR-51',
    name: 'Risk Register',
    description: 'Enterprise risk register tracking identified risks, ratings, owners, and treatment plans',
    link: '',
    complianceRequirement: null,
    controlId: 'GV.RM-01 Ex2',
    linkedSubcategoryIds: [],
    type: 'Report',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-51',
    status: 'ACTIVE'
  },
  {
    id: 52,
    artifactId: 'AR-52',
    name: 'SCRM Strategy',
    description: 'Supply chain risk management strategy document defining objectives, policies, and program scope',
    link: '',
    complianceRequirement: null,
    controlId: 'GV.SC-01 Ex3',
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-52',
    status: 'ACTIVE'
  },
  {
    id: 53,
    artifactId: 'AR-53',
    name: 'SIEM Configuration',
    description: 'Configuration documentation for SIEM capabilities via CloudTrail and GuardDuty integration',
    link: '',
    complianceRequirement: null,
    controlId: 'DE.AE-02 Ex1',
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-53',
    status: 'ACTIVE'
  },
  {
    id: 54,
    artifactId: 'AR-54',
    name: 'SIEM console screenshots',
    description: 'Screenshots of SIEM console dashboards demonstrating monitoring and log review capabilities',
    link: '',
    complianceRequirement: null,
    controlId: 'DE.AE-02 Ex3',
    linkedSubcategoryIds: [],
    type: 'Evidence',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-54',
    status: 'ACTIVE'
  },
  {
    id: 55,
    artifactId: 'AR-55',
    name: 'SOC Procedures',
    description: 'Standard operating procedures for SOC alert routing, triage, escalation, and on-call rotation',
    link: '',
    complianceRequirement: null,
    controlId: 'DE.AE-06 Ex1',
    linkedSubcategoryIds: [],
    type: 'Procedure',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-55',
    status: 'ACTIVE'
  },
  {
    id: 56,
    artifactId: 'AR-56',
    name: 'Security Awareness Program',
    description: 'Security awareness training program documentation including phishing simulations and completion tracking',
    link: '',
    complianceRequirement: null,
    controlId: 'PR.AT-01 Ex2',
    linkedSubcategoryIds: [],
    type: 'Evidence',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-56',
    status: 'ACTIVE'
  },
  {
    id: 57,
    artifactId: 'AR-57',
    name: 'Security Governance Charter',
    description: 'Board-approved charter establishing security governance structure, CISO authority, and reporting lines',
    link: '',
    complianceRequirement: null,
    controlId: 'GV.OC-01 Ex1',
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-57',
    status: 'ACTIVE'
  },
  {
    id: 58,
    artifactId: 'AR-58',
    name: 'Security Service Catalog',
    description: 'Catalog of security services provided to internal and external stakeholders',
    link: '',
    complianceRequirement: null,
    controlId: 'GV.OC-02 Ex1',
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-58',
    status: 'ACTIVE'
  },
  {
    id: 59,
    artifactId: 'AR-59',
    name: 'Self-Assessment Reports',
    description: 'Quarterly self-assessment reports documenting security posture evaluation and improvement opportunities',
    link: '',
    complianceRequirement: null,
    controlId: 'ID.IM-01 Ex1',
    linkedSubcategoryIds: [],
    type: 'Report',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-59',
    status: 'ACTIVE'
  },
  {
    id: 60,
    artifactId: 'AR-60',
    name: 'System Monitoring Policy',
    description: 'Policy governing system and application monitoring including email, web, and collaboration services',
    link: '',
    complianceRequirement: null,
    controlId: 'DE.CM-09 Ex1',
    linkedSubcategoryIds: [],
    type: 'Policy',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-60',
    status: 'ACTIVE'
  },
  {
    id: 61,
    artifactId: 'AR-61',
    name: 'Vendor Assessment Template',
    description: 'Standardized template for conducting vendor risk assessments and due diligence evaluations',
    link: '',
    complianceRequirement: null,
    controlId: 'GV.SC-06 Ex3',
    linkedSubcategoryIds: [],
    type: 'Document',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-61',
    status: 'ACTIVE'
  },
  {
    id: 62,
    artifactId: 'AR-62',
    name: 'Vendor Management Policy',
    description: 'Policy governing vendor lifecycle management from onboarding through offboarding',
    link: '',
    complianceRequirement: null,
    controlId: 'GV.SC-01 Ex3',
    linkedSubcategoryIds: [],
    type: 'Policy',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-62',
    status: 'ACTIVE'
  },
  {
    id: 63,
    artifactId: 'AR-63',
    name: 'Vendor Offboarding Checklist',
    description: 'Checklist for supplier termination including access deactivation, data return, and audit trail',
    link: '',
    complianceRequirement: null,
    controlId: 'GV.SC-10 Ex3',
    linkedSubcategoryIds: [],
    type: 'Procedure',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-63',
    status: 'ACTIVE'
  },
  {
    id: 64,
    artifactId: 'AR-64',
    name: 'Vulnerability Disclosure Policy',
    description: 'Policy defining vulnerability disclosure intake process, response SLAs, and supplier sharing requirements',
    link: '',
    complianceRequirement: null,
    controlId: 'ID.RA-08 Ex1',
    linkedSubcategoryIds: [],
    type: 'Policy',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-64',
    status: 'ACTIVE'
  },
  {
    id: 65,
    artifactId: 'AR-65',
    name: 'Vulnerability Management Program',
    description: 'Vulnerability management program documentation covering scanning, prioritization, and remediation workflows',
    link: '',
    complianceRequirement: null,
    controlId: 'ID.RA-01 Ex1',
    linkedSubcategoryIds: [],
    type: 'Evidence',
    createdDate: '2026-01-15T00:00:00.000Z',
    lastModified: '2026-01-15T00:00:00.000Z',
    jiraKey: 'AR-65',
    status: 'ACTIVE'
  }
];
